export const X2_IMAGE_SIZE_MEDIA_QUERY = '(-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi)';
